import { parseJwt } from '@src/utils/parse-jwt';

export function setItem(name: string, value: string, expiresAtMs = Date.now() + 168 * 60 * 60 * 1000): void {
	const date = new Date(expiresAtMs);
	const expires = `expires=${date.toUTCString()}`;
	document.cookie = `${name}=${value};${expires};path=/;secure;samesite=strict`;
}

export function getItem(name: string): { value: string | null; expiry: number | null } {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		// Decode the value to handle special characters correctly
		const tokenValue = parts.pop()!.split(';')[0];
		const tokenValueDecoded = decodeURIComponent(tokenValue);
		const parsedJwtToken = parseJwt(tokenValueDecoded);
		const expiry = parsedJwtToken?.exp ? parsedJwtToken.exp * 1000 : null;
		return { value: tokenValueDecoded, expiry: expiry };
	}
	return { value: null, expiry: null };
}

export function clearItem(name: string): void {
	document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;secure;samesite=strict`;
}
